// extracted by mini-css-extract-plugin
export default {"header":"qcmml9OR","rest":"eJVR7hEl","pdf-preview-container":"LS4CYGqB","pdfPreviewContainer":"LS4CYGqB","image-preview-container":"rV4vxGlK","imagePreviewContainer":"rV4vxGlK"};